import type { DevelopmentStatus } from '@/shared/utils/format-status.js';

// Espelham TECH_LEAD_ASSIGNABLE_STATUSES / ESTIMATE_SUBMITTABLE_STATUSES do backend
// (packages/backend/src/domain/models/db/development.ts) — divergir aqui só produz erro 400 vindo da API.

const TECH_LEAD_ASSIGNABLE_STATUSES: DevelopmentStatus[] = [
    'AGUARDANDO_ATRIBUICAO_TECNICA',
    'EM_ANALISE_TECNICA',
    'AGUARDANDO_APROVACAO_ESTIMATIVA',
    'ESTIMATIVA_EM_REVISAO',
    'AGUARDANDO_INICIO',
    'EM_DESENVOLVIMENTO',
    'AGUARDANDO_REVISAO_DOCUMENTACAO',
    'EM_VALIDACAO_CONSULTOR',
    'EM_VALIDACAO_USUARIO_CHAVE',
    'COM_SOLICITACOES_PENDENTES',
    'IMPEDIDO'
];

const ESTIMATE_SUBMITTABLE_STATUSES: DevelopmentStatus[] = ['EM_ANALISE_TECNICA', 'ESTIMATIVA_EM_REVISAO'];

// Espelha DEVELOPERS_SETTABLE_STATUSES do backend (packages/backend/src/domain/models/db/development.ts) —
// divergir aqui só produz erro 400 vindo da API.
const DEVELOPERS_SETTABLE_STATUSES: DevelopmentStatus[] = [
    'EM_ANALISE_TECNICA',
    'ESTIMATIVA_EM_REVISAO',
    'AGUARDANDO_INICIO',
    'EM_DESENVOLVIMENTO',
    'AGUARDANDO_REVISAO_DOCUMENTACAO',
    'EM_VALIDACAO_CONSULTOR',
    'EM_VALIDACAO_USUARIO_CHAVE',
    'COM_SOLICITACOES_PENDENTES',
    'IMPEDIDO'
];

const FULL_EDIT_STATUSES: DevelopmentStatus[] = ['EF_EM_ELABORACAO', 'EF_REJEITADA_IA'];

const TERMINAL_STATUSES: DevelopmentStatus[] = ['ENCERRADO', 'CANCELADO'];

export function isTechLeadAssignableStatus(status: DevelopmentStatus): boolean {
    return TECH_LEAD_ASSIGNABLE_STATUSES.includes(status);
}

export function isEstimateSubmittableStatus(status: DevelopmentStatus): boolean {
    return ESTIMATE_SUBMITTABLE_STATUSES.includes(status);
}

export function isDevelopersSettableStatus(status: DevelopmentStatus): boolean {
    return DEVELOPERS_SETTABLE_STATUSES.includes(status);
}

export function isFullEditStatus(status: DevelopmentStatus): boolean {
    return FULL_EDIT_STATUSES.includes(status);
}

export function isTerminalStatus(status: DevelopmentStatus): boolean {
    return TERMINAL_STATUSES.includes(status);
}
